import styled from "@mui/material/styles/styled";

import Stack from "@rui/Stack";

const MIN_HEIGHT_BREAK = "780px";

export const VideoContainer = styled(Stack)(({ theme }) => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  height: "320px",

  // special case small vertical screens
  minHeight: "213px",
  maxHeight: "213px",

  [theme.breakpoints.up("md")]: {
    borderRadius: theme.corners.small,

    // enlarge the video on screens that are both tall and wide
    [`@media (min-height: ${MIN_HEIGHT_BREAK})`]: {
      height: "320px",
      maxHeight: "100%",
    },
  },

  "& .video-metrics": {
    bottom: 42,
  },

  "& .player-controls__controls": {
    height: 0,
    visibility: "hidden",
  },

  "&:hover, &.meeting-report__video-container--focused": {
    cursor: "pointer",
    "& .player-controls": { cursor: "default" },
    "& .player-controls__controls": {
      height: "auto",
      visibility: "visible",
    },
    "& .video-metrics": {
      bottom: 66,
    },
  },

  ".video-selection-overlay + .video-controls": {
    ".player-controls__controls": {
      height: 0,
      visibility: "hidden",
    },
  },
}));

export const StyledVideo = styled("video")({
  objectFit: "contain",
  objectPosition: "center",
  width: "100%",
  height: "100%",
  zIndex: 0,
  backgroundColor: "black",
});
